var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessBlockIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_7701)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 47.5,
    fill: "#D32F2F",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4999 67.2917C44.7621 67.2917 42.1892 66.7721 39.7812 65.7331C37.3732 64.694 35.2786 63.2839 33.4973 61.5026C31.7161 59.7214 30.3059 57.6267 29.2668 55.2188C28.2278 52.8108 27.7083 50.2379 27.7083 47.5C27.7083 44.7622 28.2278 42.1892 29.2668 39.7813C30.3059 37.3733 31.7161 35.2787 33.4973 33.4974C35.2786 31.7162 37.3732 30.306 39.7812 29.2669C42.1892 28.2279 44.7621 27.7083 47.4999 27.7083C50.2378 27.7083 52.8107 28.2279 55.2187 29.2669C57.6267 30.306 59.7213 31.7162 61.5025 33.4974C63.2838 35.2787 64.6939 37.3733 65.733 39.7813C66.7721 42.1892 67.2916 44.7622 67.2916 47.5C67.2916 50.2379 66.7721 52.8108 65.733 55.2188C64.6939 57.6267 63.2838 59.7214 61.5025 61.5026C59.7213 63.2839 57.6267 64.694 55.2187 65.7331C52.8107 66.7721 50.2378 67.2917 47.4999 67.2917ZM47.4999 63.3333C49.2812 63.3333 50.9964 63.0447 52.6458 62.4675C54.2951 61.8902 55.8124 61.0573 57.1978 59.9688L35.0312 37.8021C33.9426 39.1875 33.1097 40.7049 32.5325 42.3542C31.9552 44.0035 31.6666 45.7188 31.6666 47.5C31.6666 51.9201 33.2004 55.6641 36.2681 58.7318C39.3359 61.7995 43.0798 63.3333 47.4999 63.3333ZM59.9687 57.1979C61.0572 55.8125 61.8901 54.2951 62.4674 52.6458C63.0446 50.9965 63.3333 49.2813 63.3333 47.5C63.3333 43.0799 61.7994 39.3359 58.7317 36.2682C55.664 33.2005 51.9201 31.6667 47.4999 31.6667C45.7187 31.6667 44.0034 31.9553 42.3541 32.5326C40.7048 33.1098 39.1874 33.9427 37.802 35.0313L59.9687 57.1979Z",
    fill: "#D32F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_7701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 47.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessBlockIllustration);
export default __webpack_public_path__ + "static/media/access-block-illustration.eb94d510.svg";
export { ForwardRef as ReactComponent };